import React, { useState } from "react";
import { Footer, Navbar } from "../components";
import api from "../utils/base_url";
import '../styles/ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg(null);

    try {
      const res = await api.post("contactus/", formData);
      if (res.data.success || res.data.status) {
        setResponseMsg({ type: "success", text: "Message sent successfully!" });
        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        setResponseMsg({ type: "warning", text: "Something went wrong. Please try again." });
      }
    } catch (error) {
      setResponseMsg({ type: "error", text: "Failed to send message. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="contact-page-wrapper">
        <div className="container">

          {/* Page Header */}
          <div className="contact-page-header">
            <span className="contact-page-eyebrow">Get in touch</span>
            <h1 className="contact-page-title">How can we help?</h1>
            <p className="contact-page-subtitle">
              We'd love to hear from you. Send us a message and we'll get back to you shortly.
            </p>
          </div>

          <hr className="contact-page-divider" />

          {/* Form */}
          <div className="row justify-content-center">
            <div className="col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4">
              <form onSubmit={handleSubmit} className="contact-form-card" noValidate>

                <div className="contact-form-group">
                  <label htmlFor="contact-name" className="contact-form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    className="contact-input"
                    id="contact-name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your full name"
                    required
                    autoComplete="name"
                  />
                </div>

                <div className="contact-form-group">
                  <label htmlFor="contact-email" className="contact-form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="contact-input"
                    id="contact-email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    required
                    autoComplete="email"
                  />
                </div>

                <div className="contact-form-group">
                  <label htmlFor="contact-phone" className="contact-form-label">
                    Phone
                  </label>
                  <input
                    type="tel"
                    className="contact-input"
                    id="contact-phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 00000 00000"
                    required
                    autoComplete="tel"
                  />
                </div>

                <div className="contact-form-group">
                  <label htmlFor="contact-message" className="contact-form-label">
                    Message
                  </label>
                  <textarea
                    className="contact-input"
                    id="contact-message"
                    name="message"
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us how we can help…"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="contact-btn-submit"
                  disabled={loading}
                >
                  {loading && <span className="btn-spinner" aria-hidden="true" />}
                  {loading ? "Sending…" : "Send message"}
                </button>
              </form>

              {responseMsg && (
                <div className={`contact-response-msg ${responseMsg.type}`} role="alert">
                  {responseMsg.text}
                </div>
              )}
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;